/**
 * catalog.js — DỮ LIỆU MẪU cho bản HTML tĩnh (giỏ hàng demo, gợi ý tìm kiếm, quiz).
 *
 * Chỉ tồn tại vì bản tĩnh không có server. Lên WordPress/WooCommerce thì XOÁ file này:
 * giỏ hàng lấy từ WC()->cart, gợi ý tìm kiếm gọi endpoint AJAX, kết quả quiz do PHP trả.
 *
 * Giá lưu bằng số nguyên VND (không dấu chấm) để cộng trừ không sai; chỉ format lúc in.
 * Ảnh chai lấy trong images/products/ (PNG nền trong suốt, 600×800) — trùng ảnh với dữ liệu
 * card ở partials/data/*.json để giỏ hàng, gợi ý tìm kiếm và card hiện cùng một chai.
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    var IMG_DIR = 'images/products/';
    var IMG = {
        'chateau-margaux': '4.png',
        'barolo-riserva': '9.png',
        'casillero-cabernet': '3.png',
        'penfolds-bin-389': '8.png',
        'rioja-reserva': '7.png',
        'catena-malbec': 'bottle.png',
        'mondavi-napa': '3.png',
        'nerio-salento': 'bottle.png',
        'moet-brut': '1.png',
        'cloudy-bay-sauvignon': '2.png',
        'whispering-angel': '1.png',
        'dr-loosen-riesling': '2.png',
        'tignanello-toscana': '9.png',
        'louis-jadot-pinot': '4.png',
        'montes-alpha-cabernet': '7.png',
        'wolf-blass-shiraz': '8.png',
        'louis-jadot-chablis': '2.png',
        'santa-margherita-pinot-grigio': '2.png',
        'kendall-jackson-chardonnay': '2.png',
        'villa-maria-sauvignon': '2.png',
        'veuve-clicquot-brut': '1.png',
        'mionetto-prosecco': '1.png',
        'freixenet-cava-rosado': '1.png',
        'miraval-rose': '1.png',
        'taylors-10-tawny': 'bottle.png',
        'suduiraut-sauternes': '2.png',
        'chiarlo-moscato': '2.png',
        'grahams-lbv': '7.png',
        'banfi-rosa-regale': '7.png',
        'dows-fine-ruby': 'bottle.png'
    };
    // Phụ kiện chưa có ảnh chai: giỏ hàng hiện icon nhóm Phụ kiện thay vì ảnh một chai vang
    var IMG_FULL = {
        'riedel-veritas-cabernet': 'images/categories/accessories.png',
        'riedel-decanter': 'images/categories/accessories.png'
    };
    var URL = 'single-product.html';

    // [id, tên, cờ, quốc gia, vùng, niên vụ, độ cồn, điểm, số đánh giá, giá, giá gốc, mới?, loại, giống nho, tồn kho]
    var rows = [
        ['chateau-margaux', 'Château Margaux Grand Vin', 'fr', 'Pháp', 'Bordeaux', '2018', '13.5%', 4.9, 128, 1250000, 1560000, true, 'Vang đỏ', 'Cabernet Sauvignon', 12],
        ['barolo-riserva', 'Barolo Riserva DOCG', 'it', 'Ý', 'Piedmont', '2016', '14%', 4.8, 96, 1890000, 0, false, 'Vang đỏ', 'Nebbiolo', 3],
        ['casillero-cabernet', 'Casillero del Diablo Cabernet', 'cl', 'Chile', 'Maipo', '2021', '13.5%', 4.7, 312, 390000, 450000, false, 'Vang đỏ', 'Cabernet Sauvignon', 40],
        ['penfolds-bin-389', 'Penfolds Bin 389 Cabernet Shiraz', 'au', 'Úc', 'South Australia', '2019', '14.5%', 4.8, 74, 2150000, 0, true, 'Vang đỏ', 'Shiraz', 0],
        ['rioja-reserva', 'Rioja Reserva Tempranillo', 'es', 'Tây Ban Nha', 'Rioja', '2017', '14%', 4.6, 58, 690000, 790000, false, 'Vang đỏ', 'Tempranillo', 25],
        ['catena-malbec', 'Catena Malbec Alta', 'ar', 'Argentina', 'Mendoza', '2020', '13.5%', 4.7, 41, 1150000, 0, false, 'Vang đỏ', 'Malbec', 18],
        ['mondavi-napa', 'Robert Mondavi Napa Valley', 'us', 'Mỹ', 'Napa Valley', '2019', '14.5%', 4.8, 67, 1690000, 1890000, false, 'Vang đỏ', 'Cabernet Sauvignon', 9],
        ['nerio-salento', 'Nerio Salento Rosso', 'it', 'Ý', 'Puglia', '2020', '13.5%', 4.5, 103, 450000, 0, true, 'Vang đỏ', 'Negroamaro', 30],
        ['moet-brut', 'Moët & Chandon Brut Impérial', 'fr', 'Pháp', 'Champagne', 'NV', '12%', 4.7, 88, 1450000, 0, false, 'Vang sủi', 'Pinot Noir', 15],
        ['cloudy-bay-sauvignon', 'Cloudy Bay Sauvignon Blanc', 'nz', 'New Zealand', 'Marlborough', '2022', '13%', 4.6, 52, 890000, 0, false, 'Vang trắng', 'Sauvignon Blanc', 20],
        ['whispering-angel', 'Whispering Angel Rosé', 'fr', 'Pháp', 'Provence', '2022', '13%', 4.7, 61, 790000, 890000, false, 'Vang hồng', 'Grenache', 14],
        ['dr-loosen-riesling', 'Dr. Loosen Riesling Kabinett', 'de', 'Đức', 'Mosel', '2021', '8.5%', 4.5, 33, 650000, 0, true, 'Vang trắng', 'Riesling', 22],
        ['tignanello-toscana', 'Antinori Tignanello Toscana', 'it', 'Ý', 'Tuscany', '2019', '14%', 4.8, 52, 3290000, 0, false, 'Vang đỏ', 'Sangiovese', 6],
        ['louis-jadot-pinot', 'Louis Jadot Bourgogne Pinot Noir', 'fr', 'Pháp', 'Bourgogne', '2020', '12.5%', 4.6, 44, 890000, 990000, false, 'Vang đỏ', 'Pinot Noir', 16],
        ['montes-alpha-cabernet', 'Montes Alpha Cabernet Sauvignon', 'cl', 'Chile', 'Colchagua', '2020', '14%', 4.7, 138, 690000, 0, false, 'Vang đỏ', 'Cabernet Sauvignon', 24],
        ['wolf-blass-shiraz', 'Wolf Blass Yellow Label Shiraz', 'au', 'Úc', 'South Australia', '2021', '13.5%', 4.4, 86, 420000, 0, true, 'Vang đỏ', 'Shiraz', 30],
        ['louis-jadot-chablis', 'Louis Jadot Chablis', 'fr', 'Pháp', 'Bourgogne', '2021', '12.5%', 4.6, 41, 1090000, 1250000, false, 'Vang trắng', 'Chardonnay', 14],
        ['santa-margherita-pinot-grigio', 'Santa Margherita Pinot Grigio', 'it', 'Ý', 'Alto Adige', '2022', '12.5%', 4.5, 37, 720000, 0, false, 'Vang trắng', 'Pinot Grigio', 20],
        ['kendall-jackson-chardonnay', 'Kendall-Jackson Vintner\'s Reserve Chardonnay', 'us', 'Mỹ', 'California', '2021', '13.5%', 4.6, 49, 850000, 0, true, 'Vang trắng', 'Chardonnay', 12],
        ['villa-maria-sauvignon', 'Villa Maria Private Bin Sauvignon Blanc', 'nz', 'New Zealand', 'Marlborough', '2022', '12.5%', 4.5, 58, 560000, 620000, false, 'Vang trắng', 'Sauvignon Blanc', 26],
        ['veuve-clicquot-brut', 'Veuve Clicquot Yellow Label Brut', 'fr', 'Pháp', 'Champagne', 'NV', '12%', 4.8, 97, 1690000, 0, false, 'Vang sủi', 'Pinot Noir', 10],
        ['mionetto-prosecco', 'Mionetto Prosecco Brut', 'it', 'Ý', 'Veneto', 'NV', '11%', 4.6, 52, 490000, 560000, false, 'Vang sủi', 'Glera', 35],
        ['freixenet-cava-rosado', 'Freixenet Cava Rosado', 'es', 'Tây Ban Nha', 'Penedès', 'NV', '12%', 4.5, 33, 420000, 0, true, 'Vang sủi', 'Trepat', 28],
        ['miraval-rose', 'Château Miraval Rosé', 'fr', 'Pháp', 'Provence', '2022', '13%', 4.7, 46, 980000, 0, false, 'Vang hồng', 'Cinsault', 16],
        ['taylors-10-tawny', 'Taylor\'s 10 Year Old Tawny Port', 'pt', 'Bồ Đào Nha', 'Douro', 'NV', '20%', 4.8, 47, 1150000, 0, false, 'Vang cường hoá', 'Touriga Nacional', 11],
        ['suduiraut-sauternes', 'Château Suduiraut Sauternes', 'fr', 'Pháp', 'Bordeaux', '2017', '14%', 4.7, 29, 1650000, 0, false, 'Vang ngọt', 'Sémillon', 6],
        ['chiarlo-moscato', 'Michele Chiarlo Moscato d\'Asti', 'it', 'Ý', 'Piedmont', '2022', '5.5%', 4.6, 61, 520000, 590000, false, 'Vang ngọt', 'Moscato', 30],
        ['grahams-lbv', 'Graham\'s Late Bottled Vintage Port', 'pt', 'Bồ Đào Nha', 'Douro', '2018', '20%', 4.5, 26, 890000, 0, false, 'Vang cường hoá', 'Touriga Franca', 9],
        ['banfi-rosa-regale', 'Banfi Rosa Regale Brachetto d\'Acqui', 'it', 'Ý', 'Piedmont', '2022', '7%', 4.6, 34, 680000, 750000, false, 'Vang ngọt', 'Brachetto', 18],
        ['dows-fine-ruby', 'Dow\'s Fine Ruby Port', 'pt', 'Bồ Đào Nha', 'Douro', 'NV', '19%', 4.4, 21, 590000, 0, true, 'Vang cường hoá', 'Touriga Nacional', 22],
        ['riedel-veritas-cabernet', 'Ly Riedel Veritas Cabernet (hộp 2 ly)', '', 'Áo', 'Riedel', '—', '—', 4.8, 64, 890000, 990000, false, 'Phụ kiện', '', 40],
        ['riedel-decanter', 'Bình decanter pha lê Riedel Cabernet', '', 'Áo', 'Riedel', '—', '—', 4.7, 31, 1190000, 0, false, 'Phụ kiện', '', 15]
    ];

    var products = rows.map(function (r) {
        return {
            id: r[0],
            name: r[1],
            flag: r[2],
            country: r[3],
            region: r[4],
            year: r[5],
            abv: r[6],
            rating: r[7],
            reviews: r[8],
            price: r[9],
            regularPrice: r[10] || 0,
            isNew: r[11],
            type: r[12],
            grape: r[13],
            stock: r[14],
            volume: '750ml',
            image: IMG_FULL[r[0]] || IMG_DIR + (IMG[r[0]] || 'bottle.png'),
            url: URL,
            meta: r[12] === 'Phụ kiện' ? 'Phụ kiện · ' + r[4] : r[3] + ' · ' + r[5] + ' · 750ml'
        };
    });

    var byId = {};
    products.forEach(function (p) {
        byId[p.id] = p;
    });

    window.WBCatalog = {
        all: function () {
            return products.slice();
        },
        get: function (id) {
            return byId[id] || null;
        },
        // Từ khoá gợi ý khi gõ (mục 21) — vùng, giống nho, quốc gia, loại vang
        keywords: [
            'Bordeaux', 'Bourgogne', 'Barolo', 'Cabernet Sauvignon', 'Champagne', 'Chile', 'Ý', 'Úc',
            'Merlot', 'Malbec', 'Pinot Noir', 'Prosecco', 'Rioja', 'Shiraz', 'Vang đỏ', 'Vang trắng',
            'Vang sủi', 'Quà tặng'
        ],
        popular: ['Bordeaux', 'Cabernet', 'Quà Tết', 'Vang sủi']
    };
})();
